import React, { useEffect, useState } from 'react';
import { MessageCircle, Loader, Check } from 'lucide-react';
import authService from '../../services/authService';
import { debugError } from '../../utils/logger';

// Toggle reutilizable de consentimiento de WhatsApp para la pantalla de perfil.
// Carga el estado actual desde /auth/me y lo actualiza vía PUT /auth/whatsapp-opt-in.
function WhatsappOptInToggle() {
  const [optIn, setOptIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await authService.getMe();
        if (mounted) setOptIn(res?.data?.user?.whatsappOptIn === true);
      } catch (err) {
        debugError('Error cargando opt-in de WhatsApp:', err);
        if (mounted) setError('No se pudo cargar tu preferencia de WhatsApp');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const handleToggle = async () => {
    const next = !optIn;
    setSaving(true);
    setError('');
    setOptIn(next); // optimista
    try {
      const res = await authService.updateWhatsappOptIn(next);
      setOptIn(res?.data?.whatsappOptIn === true);
      setSavedAt(Date.now());
      setTimeout(() => setSavedAt(null), 2500);
    } catch (err) {
      debugError('Error actualizando opt-in de WhatsApp:', err);
      setOptIn(!next); // revertir
      setError('No se pudo actualizar tu preferencia. Intenta de nuevo.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 max-w-xl">
      <div className="flex items-center gap-3 mb-4">
        <MessageCircle className="h-6 w-6 text-green-600" />
        <h3 className="text-lg font-bold text-gray-800">Recordatorios por WhatsApp</h3>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-gray-500">
          <Loader className="h-4 w-4 animate-spin" /> Cargando preferencia...
        </div>
      ) : (
        <>
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={optIn}
              onChange={handleToggle}
              disabled={saving}
              className="h-5 w-5 text-green-600 focus:ring-green-500 border-gray-300 rounded mt-0.5"
            />
            <span className="text-sm text-gray-700">
              Quiero recibir recordatorios de mis citas por WhatsApp
              <span className="block text-xs text-gray-500 mt-1">
                Te enviaremos un mensaje unos minutos antes de cada cita con el enlace directo a tu
                consulta. Puedes desactivarlo en cualquier momento.
              </span>
            </span>
          </label>

          <div className="mt-3 min-h-[20px] text-sm">
            {saving && (
              <span className="text-gray-500 inline-flex items-center gap-1">
                <Loader className="h-3 w-3 animate-spin" /> Guardando...
              </span>
            )}
            {!saving && savedAt && (
              <span className="text-green-600 inline-flex items-center gap-1">
                <Check className="h-4 w-4" /> Preferencia guardada
              </span>
            )}
            {error && <span className="text-red-600">{error}</span>}
          </div>
        </>
      )}
    </div>
  );
}

export default WhatsappOptInToggle;
